<template>
	<div class="app-main" :style="{ minHeight: mainHeight + 'px' }">
		<section class="main-wrap">
			<breadcrumb class="breadcrumb-container"></breadcrumb>
			<transition name="fade-transform" mode="out-in">
				<keep-alive :include="cacheviews">
					<router-view :key="key"></router-view>
				</keep-alive>
			</transition>
		</section>
	</div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'

export default {
	name: 'AppMain',
	components: {
		Breadcrumb,
	},
	data() {
		return {
			mainHeight: 0
		}
	},
	computed: {
		key() {
			return this.$route.fullPath
		},

		cacheviews() {
			return this.$store.state.app.cacheviews
		}
	},
	mounted() {
		this.mainHeight = this.$root.$el.clientHeight - 64
		this.$store.dispatch('setMainHeight', this.mainHeight)
	}
}
</script>
